export const QA_TABS = {
  allQuestions: 'all-questions',
  new: 'new',
  contacted: 'contacted',
  answered: 'answered',
};
